/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateFapDto } from '../models/CreateFapDto';
import type { FapResponseDto } from '../models/FapResponseDto';
import type { PaginatedFapsResponseDto } from '../models/PaginatedFapsResponseDto';
import type { UpdateFapDto } from '../models/UpdateFapDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FaPsService {
    /**
     * Create a new FAP
     *
     * Creates a new Financial Advice Provider (FAP) in the database.
     *
     * **Authorization Required:**
     * - Requires JWT authentication token
     * - Requires BUSINESS_ADMIN or SUPER_ADMIN role
     *
     * **Notes:**
     * - fapLicenceNumber must be unique across all FAPs
     * - Primary contact details are required
     * - Banking details are required for payment processing
     *
     * @param requestBody FAP creation data
     * @returns FapResponseDto FAP created successfully
     * @throws ApiError
     */
    public static fapsControllerCreate(
        requestBody: CreateFapDto,
    ): CancelablePromise<FapResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/faps',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - invalid input data`,
                401: `Unauthorized - JWT token missing or invalid`,
                403: `Forbidden - User does not have BUSINESS_ADMIN or SUPER_ADMIN role`,
                409: `Conflict - FAP licence number already exists`,
            },
        });
    }
    /**
     * List all FAPs
     *
     * Retrieves a paginated list of FAPs with optional filtering and sorting.
     *
     * **Authorization Required:**
     * - Requires JWT authentication token
     * - Requires BUSINESS_ADMIN or SUPER_ADMIN role
     *
     * **Role-based Access:**
     * - SUPER_ADMIN and BUSINESS_ADMIN: Can see all FAPs
     *
     * **Filtering Options:**
     * - search: Filter by legal name, trading name, or licence number (case-insensitive)
     * - status: Filter by FAP status (active, inactive)
     *
     * **Sorting:**
     * - sortBy: Field to sort by (legalName, tradingName, fapLicenceNumber, createdAt, updatedAt, status)
     * - sortOrder: asc or desc
     *
     * **Pagination:**
     * - page: Page number (1-based, default: 1)
     * - limit: Items per page (1-100, default: 10)
     *
     * @param page Page number (1-based)
     * @param limit Number of items per page
     * @param search Search term to filter by legal name, trading name, or licence number
     * @param status Filter by FAP status
     * @param sortBy Sort field
     * @param sortOrder Sort order
     * @returns PaginatedFapsResponseDto List of FAPs with pagination metadata
     * @throws ApiError
     */
    public static fapsControllerFindAll(
        page: number = 1,
        limit: number = 10,
        search?: string,
        status?: 'active' | 'inactive',
        sortBy: 'legalName' | 'tradingName' | 'fapLicenceNumber' | 'createdAt' | 'updatedAt' | 'status' = 'createdAt',
        sortOrder: 'asc' | 'desc' = 'desc',
    ): CancelablePromise<PaginatedFapsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/faps',
            query: {
                'page': page,
                'limit': limit,
                'search': search,
                'status': status,
                'sortBy': sortBy,
                'sortOrder': sortOrder,
            },
            errors: {
                401: `Unauthorized - JWT token missing or invalid`,
                403: `Forbidden - user does not have required role`,
            },
        });
    }
    /**
     * Get a FAP by ID
     *
     * Retrieves a single FAP by their UUID.
     *
     * **Authorization Required:**
     * - Requires JWT authentication token
     * - Requires BUSINESS_ADMIN or SUPER_ADMIN role
     *
     * **Role-based Access:**
     * - SUPER_ADMIN and BUSINESS_ADMIN: Can view any FAP
     *
     * **Includes:**
     * - FAP details
     * - Primary contact information
     * - Banking details
     *
     * @param id FAP UUID
     * @returns FapResponseDto FAP found
     * @throws ApiError
     */
    public static fapsControllerFindOne(
        id: string,
    ): CancelablePromise<FapResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/faps/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized - JWT token missing or invalid`,
                403: `Forbidden - user does not have required role or access to this FAP`,
                404: `FAP not found`,
            },
        });
    }
    /**
     * Update a FAP
     *
     * Updates an existing FAP with the provided data.
     *
     * **Notes:**
     * - Only provided fields are updated (partial update)
     * - fapLicenceNumber must remain unique if provided
     *
     * @param id FAP UUID
     * @param requestBody FAP update data
     * @returns FapResponseDto FAP updated successfully
     * @throws ApiError
     */
    public static fapsControllerUpdate(
        id: string,
        requestBody: UpdateFapDto,
    ): CancelablePromise<FapResponseDto> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/api/v1/faps/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request - invalid input data`,
                401: `Unauthorized - JWT token missing or invalid`,
                404: `FAP not found`,
                409: `Conflict - FAP licence number already exists`,
            },
        });
    }
    /**
     * Delete a FAP
     *
     * Soft-deletes a FAP by setting the deletedAt timestamp.
     *
     * **Notes:**
     * - The FAP is not permanently deleted
     * - Soft-deleted FAPs are excluded from list queries
     * - Related data (advisers, users, etc.) is preserved
     *
     * @param id FAP UUID
     * @returns void
     * @throws ApiError
     */
    public static fapsControllerRemove(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/faps/{id}',
            path: {
                'id': id,
            },
            errors: {
                401: `Unauthorized - JWT token missing or invalid`,
                404: `FAP not found`,
            },
        });
    }
}
